import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BackgroundGrid',
  props: {
    gridMargin: {},
    columnWidth: {},
    rowHeight: {},
    show: { type: Boolean }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "75eb1b96": (display.value),
  "66fd700e": (width.value),
  "ac4e8558": (height.value),
  "9ba69c4a": (margin.value),
  "4274b180": (backgroundImage.value),
  "7ad1117c": (backgroundSize.value)
}))

const props = __props;

const display = computed(() => (props.show ? "block" : "none"));

const width = computed(() => `calc(100% - ${2 * props.gridMargin}px`);
const height = computed(() => width.value);

const margin = computed(() => `${props.gridMargin}px`);

const backgroundSize = computed(
  () => `${props.columnWidth + props.gridMargin}px ${props.rowHeight + props.gridMargin}px`,
);
const backgroundImage = computed(() => {
  const columnRatio = (props.columnWidth / (props.gridMargin + props.columnWidth)) * 100;
  const rowRatio = (props.rowHeight / (props.gridMargin + props.rowHeight)) * 100;
  const backgroundColor = "#f9fafb";
  return `linear-gradient(to bottom, transparent ${rowRatio}%, ${backgroundColor} ${rowRatio}%), linear-gradient(to right, #e5e7eb ${columnRatio}%, ${backgroundColor} ${columnRatio}%)`;
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})